import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import useGroups from '@/hooks/contacts/use-groups';
import type { ConversationSessionsTypeUnion } from '@/models/conversations/conversation-session';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { generateSessionKey } from '@/utils/session';

interface Props {
  session: ConversationSessionsTypeUnion;
  hasDraft: boolean;
}

export function SessionListItemAlert({ session, hasDraft }: Props) {
  const isGroup = session.SessionType === 'group';
  const { groups } = useGroups();
  const group = isGroup ? groups[session.ID] : undefined;
  const { t } = useTranslation();
  const lastReadNotice = useConversationSessionStore(
    (s) => s.lastReadNotices[generateSessionKey(session.SessionType, session.ID)],
  );

  let content: ReactNode = null;

  if (hasDraft) {
    content = t('conversation.list.alert.draft');
  }

  if (isGroup) {
    if (session.GotAt) {
      content = t('conversation.list.alert.tag');
    }
    if (group?.Info && group.Info !== lastReadNotice) {
      content = t('conversation.list.alert.announcement');
    }
  }

  if (!content) return null;

  return <span className='whitespace-nowrap pr-1 text-red-700'>[{content}]</span>;
}
